import { injectStyle } from "./../../../../utils/style";
import { h } from "./../../../../utils/createElement";
import { __extends } from "tslib";
import { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import DateConstants from './DateConstants';
import { getTitleString, getTodayTime } from '../util';
import dayjs from '../dayjs';
import { shallowEqual } from '../../../../utils/helper';
injectStyle("components/DatePicker/rc-calendar/style/common/DateTBody.css", "[data-dui-0-122-5~=\"dui-calendar-today\"] [data-dui-0-122-5~=\"dui-calendar-date\"]{background:var(--feedback-hover,rgba(51,77,102,.06))}[data-dui-0-122-5~=\"dui-calendar-disabled-cell\"] [data-dui-0-122-5~=\"dui-calendar-date\"]{width:auto;background:#f5f5f5;border-radius:0;color:var(--text-weak,rgba(0,0,0,.24));cursor:not-allowed!important}[data-dui-0-122-5~=\"dui-calendar-disabled-cell-first-of-row\"] [data-dui-0-122-5~=\"dui-calendar-date\"]{border-bottom-left-radius:4px;border-top-left-radius:4px}[data-dui-0-122-5~=\"dui-calendar-disabled-cell-last-of-row\"] [data-dui-0-122-5~=\"dui-calendar-date\"]{border-bottom-right-radius:4px;border-top-right-radius:4px}[data-dui-0-122-5~=\"dui-calendar-last-month-cell\"] [data-dui-0-122-5~=\"dui-calendar-date\"],[data-dui-0-122-5~=\"dui-calendar-next-month-cell\"] [data-dui-0-122-5~=\"dui-calendar-date\"]{color:var(--text-weak,rgba(0,0,0,.24))}[data-dui-0-122-5~=\"dui-calendar-selected-day\"] [data-dui-0-122-5~=\"dui-calendar-date\"]{background:var(--feedback-hover,rgba(51,77,102,.06))}[data-dui-0-122-5~=\"dui-calendar-selected-date\"] [data-dui-0-122-5~=\"dui-calendar-date\"]{color:var(--text-link,#175ceb)}[data-dui-0-122-5~=\"dui-calendar-selected-date\"] [data-dui-0-122-5~=\"dui-calendar-date\"],[data-dui-0-122-5~=\"dui-calendar-selected-date\"] [data-dui-0-122-5~=\"dui-calendar-date\"]:hover{background:var(--tsp-fill-accent-ultrastrong,rgba(30,111,255,.16))}[data-dui-0-122-5~=\"dui-calendar-date\"]{display:block;width:24px;height:24px;padding:0;margin:3px auto;background:transparent;border-radius:2px;color:var(--text-ultrastrong,rgba(0,0,0,.88));line-height:24px;text-align:center}[data-dui-0-122-5~=\"dui-calendar-date\"]:hover{background:rgba(0,0,0,.04);cursor:pointer}");
var emptyFn = function () { };
export function isSameDay(one, two) {
    var _a;
    return (_a = (one && two && one.isSame(two, 'day'))) !== null && _a !== void 0 ? _a : false;
}
export function beforeCurrentMonthYear(current, today) {
    if (current.year() < today.year()) {
        return true;
    }
    return current.year() === today.year() && current.month() < today.month();
}
export function afterCurrentMonthYear(current, today) {
    if (current.year() > today.year()) {
        return true;
    }
    return current.year() === today.year() && current.month() > today.month();
}
export function getIdFromDate(date) {
    return "dui-calendar-" + date.year() + "-" + date.month() + "-" + date.date();
}
var DateTBody = (function (_super) {
    __extends(DateTBody, _super);
    function DateTBody() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DateTBody.prototype.shouldComponentUpdate = function (nextProps) {
        if (nextProps.disabledDate) {
            return true;
        }
        return !shallowEqual(this.props, nextProps);
    };
    DateTBody.prototype.renderTable = function (dateTable) {
        var _a = this.props, contentRender = _a.contentRender, prefixCls = _a.prefixCls, selectedValue = _a.selectedValue, value = _a.value, showWeekNumber = _a.showWeekNumber, dateRender = _a.dateRender, disabledDate = _a.disabledDate, hoverValue = _a.hoverValue, onDayHover = _a.onDayHover, onSelect = _a.onSelect;
        var today = getTodayTime(value);
        var passed = 0;
        var tableHtml = Array.from({ length: DateConstants.DATE_ROW_COUNT }).reduce(function (htmlArr, _, index) {
            var _a;
            var isActiveWeek = false;
            var isCurrentWeek = false;
            var weekNumberCell = showWeekNumber ? (function () {
                var weekNumber = dateTable[passed].week();
                return (h("td", { key: weekNumber, className: prefixCls + "-week-number-cell", role: "gridcell" }, weekNumber));
            })() : null;
            var dateCells = Array.from({ length: DateConstants.DATE_COL_COUNT }).reduce(function (memo, __, colIndex) {
                var _a;
                var _b;
                var current = dateTable[passed];
                var isBeforeCurrentMonthYear = beforeCurrentMonthYear(current, value);
                var isAfterCurrentMonthYear = afterCurrentMonthYear(current, value);
                var rangeClass;
                var selected = false;
                if (Array.isArray(selectedValue)) {
                    (function () {
                        if (isBeforeCurrentMonthYear || isAfterCurrentMonthYear) {
                            return;
                        }
                        var rangeValue = hoverValue.length ? hoverValue : selectedValue;
                        var startValue = rangeValue[0], endValue = rangeValue[1];
                        if (!startValue && !endValue) {
                            return;
                        }
                        var isCurrentStart = isSameDay(current, startValue);
                        var isCurrentEnd = isSameDay(current, endValue);
                        if (isCurrentStart || isCurrentEnd) {
                            selected = true;
                            isActiveWeek = true;
                            rangeClass = isCurrentStart ? prefixCls + "-selected-start-date" : prefixCls + "-selected-end-date";
                            return;
                        }
                        if ((!startValue && current.isBefore(endValue))
                            || (!endValue && current.isAfter(startValue))
                            || (current.isAfter(startValue) && current.isBefore(endValue))) {
                            rangeClass = prefixCls + "-in-range-cell";
                        }
                    })();
                }
                else if (isSameDay(current, value)) {
                    selected = true;
                    isActiveWeek = true;
                }
                var next = colIndex < DateConstants.DATE_COL_COUNT - 1 ? dateTable[passed + 1] : null;
                var last = colIndex > 0 ? dateTable[passed - 1] : null;
                var disabled = (_b = disabledDate === null || disabledDate === void 0 ? void 0 : disabledDate(current, value)) !== null && _b !== void 0 ? _b : false;
                var _c = disabled ? {
                    isFirstDisabledOfRow: !last || !disabledDate(last, value),
                    isLastDisabledOfRow: !next || !disabledDate(next, value),
                } : {}, isFirstDisabledOfRow = _c.isFirstDisabledOfRow, isLastDisabledOfRow = _c.isLastDisabledOfRow;
                var dateHtml = dateRender ? dateRender(current, value) : (h("div", { key: getIdFromDate(current), "aria-disabled": disabled, "aria-selected": selected, className: prefixCls + "-date" }, contentRender ? contentRender(current, value) : current.date()));
                var isToday = isSameDay(current, today);
                isCurrentWeek = isCurrentWeek || isToday;
                var createPropsClosure = function (func, arg) { return function () { return func(arg); }; };
                var dateCellElement = (h("td", { key: passed, role: "gridcell", title: getTitleString(current), className: classNames(rangeClass, prefixCls + "-cell", (_a = {},
                        _a[prefixCls + "-today"] = isToday,
                        _a[prefixCls + "-last-month-cell"] = isBeforeCurrentMonthYear,
                        _a[prefixCls + "-next-month-cell"] = isAfterCurrentMonthYear,
                        _a[prefixCls + "-selected-date"] = isSameDay(current, selectedValue),
                        _a[prefixCls + "-last-day-of-month"] = isSameDay(current, current.clone().endOf('month')),
                        _a[prefixCls + "-disabled-cell"] = disabled,
                        _a[prefixCls + "-selected-day"] = selected,
                        _a[prefixCls + "-disabled-cell-first-of-row"] = isFirstDisabledOfRow,
                        _a[prefixCls + "-disabled-cell-last-of-row"] = isLastDisabledOfRow,
                        _a)), onClick: disabled ? undefined : createPropsClosure(onSelect, current), onMouseEnter: disabled ? undefined : createPropsClosure(onDayHover, current) }, dateHtml));
                memo.push(dateCellElement);
                passed += 1;
                return memo;
            }, []);
            var rowElement = (h("tr", { key: "" + index.toString(), role: "row", className: classNames((_a = {},
                    _a[prefixCls + "-current-week"] = isCurrentWeek,
                    _a[prefixCls + "-active-week"] = isActiveWeek,
                    _a)) },
                weekNumberCell,
                dateCells));
            htmlArr.push(rowElement);
            return htmlArr;
        }, []);
        return tableHtml;
    };
    DateTBody.prototype.render = function () {
        var _a = this.props, prefixCls = _a.prefixCls, value = _a.value;
        var month = value.clone().date(1);
        var day = month.day();
        var lastMonthDiffDay = (day + 7 - value.localeData().firstDayOfWeek()) % 7;
        var lastMonth = month.clone().add(0 - lastMonthDiffDay, 'days');
        var current;
        var dateTable = Array.from({
            length: DateConstants.DATE_ROW_COUNT * DateConstants.DATE_COL_COUNT,
        }).reduce(function (memo, _, index) {
            current = lastMonth.clone().add(index, 'days');
            memo.push(current);
            return memo;
        }, []);
        return (h("tbody", { className: prefixCls + "-tbody" }, this.renderTable(dateTable)));
    };
    return DateTBody;
}(Component));
DateTBody.propTypes = {
    contentRender: PropTypes.func,
    dateRender: PropTypes.func,
    disabledDate: PropTypes.func,
    hoverValue: PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(PropTypes.object)]),
    prefixCls: PropTypes.string,
    selectedValue: PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(PropTypes.object)]),
    showWeekNumber: PropTypes.bool,
    value: PropTypes.instanceOf(dayjs),
    onDayHover: PropTypes.func,
    onSelect: PropTypes.func,
};
DateTBody.defaultProps = {
    contentRender: undefined,
    dateRender: undefined,
    disabledDate: undefined,
    hoverValue: [],
    onDayHover: emptyFn,
    onSelect: emptyFn,
    prefixCls: '',
    selectedValue: undefined,
    showWeekNumber: false,
    value: undefined,
};
export default DateTBody;
